import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../../../init-store';
import { SELF } from '../../../../shared/constants';
import { selectVisibleParticipantsList, selectWaitingRoomPeers } from '../../selectors';
import { Participant, WaitingRoomPeerState } from '../../types';
import { buildSearchQueryParts, matchesDisplayName } from './helpers';

export const selectParticipantsSearchQuery = (state: RootState) => state.call.participantsSearch.query;

const filterParticipants = (participants: (Participant | WaitingRoomPeerState)[], query: string) => {
    const queryParts = buildSearchQueryParts(query);
    return participants.filter(
        ({ id, displayName }) => id !== SELF && displayName !== undefined && matchesDisplayName(displayName, queryParts)
    );
};

const selectFilteredParticipants = createSelector(
    [selectVisibleParticipantsList, selectParticipantsSearchQuery],
    filterParticipants
);

const selectFilteredWaitingRoomPeers = createSelector(
    [selectWaitingRoomPeers, selectParticipantsSearchQuery],
    filterParticipants
);

export const selectParticipantSearchResult = createSelector(
    [selectFilteredParticipants, selectFilteredWaitingRoomPeers, selectParticipantsSearchQuery],
    (filteredParticipants, filteredWaitingRoomPeers, query) => {
        if (query.length === 0) {
            return null;
        }
        return [...filteredParticipants, ...filteredWaitingRoomPeers].sort(({ displayName: a }, { displayName: b }) => {
            if (a === undefined) {
                return 1;
            }
            if (b === undefined) {
                return -1;
            }
            return a.localeCompare(b, undefined, { sensitivity: 'base' });
        });
    }
);
